import { formatDate } from '@angular/common';
import { getTimeZoneOffset } from '@osos/shared/legacy-common';
import { DataTypeEnum } from '@osos/shared/types';

export function mapCollectionItemValue(
  itemValue,
  lookupType,
  locale_id,
  userUiSettings,
) {
  let value = itemValue;
  switch (lookupType) {
    case DataTypeEnum.Date:
      value = formatDate(value, userUiSettings.dateFormat, locale_id);
      break;
    case DataTypeEnum.Time:
      value = formatDate(value, userUiSettings.timeFormat, locale_id);
      break;
    case DataTypeEnum.DateTime:
      value = formatDate(
        value,
        userUiSettings.dateTimeFormat,
        locale_id,
        getTimeZoneOffset(userUiSettings.timeZone),
      );
      break;
  }
  return value;
}
